export const extractFilename = (contentDisposition: string): string | null => {
  if (!contentDisposition) return null;

  const filenameStarRegex = /filename\*\s*=\s*[^']*'[^']*'([^;]+)/i;
  const matchStar = contentDisposition.match(filenameStarRegex);
  if (matchStar) {
    return decodeURIComponent(matchStar[1]);
  }

  const filenameRegex = /filename\s*=\s*"?([^";]+)"?/i;
  const match = contentDisposition.match(filenameRegex);
  if (match) {
    return match[1];
  }

  return contentDisposition;
};

export const saveFileFromBlob = (contentDisposition: string, data: Blob): void => {
  const filename = extractFilename(contentDisposition) || contentDisposition;

  const url = window.URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = url;

  link.setAttribute('download', filename);

  document.body.appendChild(link);
  link.click();
  link.remove();
};
